import { useState } from 'react';

import authenticationService from 'services/AuthenticationService';
import { useAppMode } from 'contexts/AppModeContext';
import authentication from 'configs/authentication';
import LoginComponent from 'modules/accountManagement/components/LoginComponent';

const { redirectUrlCookieName } = authentication;
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginContainer: React.FC = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { isEmbedded } = useAppMode() as { isEmbedded: boolean };
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authenticationError, setAuthenticationError] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSubmitBtnClick = async () => {
    setIsAuthenticating(true);
    try {
      // Use unified authentication service
      const dateAfterOneWeek = new Date(new Date().setHours(168));
      await authenticationService.login({ expirationDate: dateAfterOneWeek });

      const returnURL = sessionStorage.getItem(redirectUrlCookieName) || '/';
      document.location.href = returnURL;
    } catch (error: unknown) {
      setIsAuthenticating(false);
      const errorMessage =
        (error as { errorMessage?: string })?.errorMessage ||
        (error as { message?: string })?.message ||
        'Login failed';
      setAuthenticationError(errorMessage);
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginComponent
      isAuthenticating={isAuthenticating}
      authenticationError={authenticationError}
      handleSubmitBtnClick={handleSubmitBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

export default LoginContainer;
